import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import SessionCategoryForm from "./SessionCategoryForm";
import { fetchSessionCategory, updateSessionCategory } from "../../store/slices/sessionCategorySlice";
import { getApiErrorMessage } from "../../utils/apiError";

const EditSessionCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { currentSessionCategory, isLoading, error } = useSelector(
        (state) => state.sessionCategories
    );

    const [formData, setFormData] = useState({
        name: "",
        status: "active",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (id) {
            dispatch(fetchSessionCategory(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (currentSessionCategory && Object.keys(currentSessionCategory).length > 0) {
            setFormData({
                name: currentSessionCategory.name || "",
                status: currentSessionCategory.status || "active",
            });
        }
    }, [currentSessionCategory]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = "Name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            await dispatch(updateSessionCategory({ id, formData })).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Session Category updated successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate("/session-categories");
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: getApiErrorMessage(err, "Failed to update Session Category"),
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    if (isLoading) return <div className="p-3">Loading...</div>;
    if (error) return <div className="p-3 text-danger">{error}</div>;

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <SessionCategoryForm
                                formData={formData}
                                handleChange={handleChange}
                            />

                            <div className="row mt-3">
                                <div className="col-md-2 ms-auto">
                                    <button type="submit" className="btn btn-primary w-100 sticky-form-submit">
                                        <i className="ri-edit-2-line me-1"></i> Update
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditSessionCategory;
